import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";

export function Privacy() {
  return <Legal title="Privacy Policy" body={PRIVACY_TEXT} />;
}
export function Terms() {
  return <Legal title="Terms of Service" body={TERMS_TEXT} />;
}
export function NotFound() {
  return (
    <div className="min-h-screen grid place-items-center bg-background text-foreground">
      <div className="text-center">
        <div className="overline mb-2">404 · NOT FOUND</div>
        <div className="text-3xl font-semibold mb-4">This route does not exist.</div>
        <Link to="/"><Button className="rounded-sm bg-primary hover:bg-primary/90">Return home</Button></Link>
      </div>
    </div>
  );
}

function Legal({ title, body }) {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <div className="max-w-3xl mx-auto p-10">
        <div className="overline mb-2">SITESYNC / LEGAL</div>
        <h1 className="text-4xl font-semibold tracking-tighter mb-8">{title}</h1>
        <div className="prose prose-invert max-w-none text-sm leading-relaxed whitespace-pre-wrap font-sans text-muted-foreground">
          {body}
        </div>
        <div className="mt-10">
          <Link to="/"><Button variant="outline" className="rounded-sm border-border">← Back home</Button></Link>
        </div>
      </div>
    </div>
  );
}

const PRIVACY_TEXT = `SiteSync collects only the data required to operate our construction management platform.

Data we collect
• Account data — name, email, role, company you belong to
• Location data — GPS coordinates during clock in / out (used to verify geofence compliance)
• Operational data — ITP results, daily logs, chat messages, attendance records

How we use it
• To provide the SiteSync features you request
• To secure your account (JWT tokens, encrypted at rest)
• To improve our platform in aggregate — never sold to third parties

Data retention
• Records are retained while your company account is active
• You may request export or deletion by contacting your company admin

Contact
privacy@sitesync.io`;

const TERMS_TEXT = `Welcome to SiteSync. By creating a company account you agree to these terms.

1. Accounts
You are responsible for the accuracy of the data you enter. Company admins are responsible for who they approve into the workspace.

2. Acceptable use
SiteSync is provided for legitimate construction site operations. Any misuse (spam, harassment, fraudulent time entries) may result in account suspension.

3. Data ownership
Your company owns the data you submit. SiteSync acts as a processor.

4. Availability
We aim for high uptime but do not guarantee 100% availability. Scheduled maintenance may occur.

5. Termination
Either party may terminate service. Company admins may export data before termination.

Contact
legal@sitesync.io`;
